var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('Loading'):_vm._e(),(_vm.isAdmin && !_vm.loading)?_c('Disposals',{attrs:{"bookings":_vm.getAdminDisposals}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }